import React, { useMemo } from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

import { IS_WEB } from '@utils';
import { SubtitlesText } from './SubtitlesText';
import type {
  PlayerSubtitlesType,
  IVideoPlayerStore,
} from './VideoPlayer';
import { useVideoPlayerSettings } from './hooks/useVideoPlayerSettings';

interface IContainerStyleProps {
  insets: EdgeInsets;
  isInFullScreen: boolean;
}

const Container = styled(View)((props: IContainerStyleProps) => {
  let bottom = IS_WEB ? 90 : 40;

  if (props.isInFullScreen && !IS_WEB) {
    bottom = props.insets.bottom + 60;
  }

  return {
    position: 'absolute',
    justifyContent: 'flex-start',
    alignItems: 'center',
    bottom,
    width: '100%',
  };
});

export interface ISubtitlesProps {
  store: IVideoPlayerStore;
  subtitles?: PlayerSubtitlesType;
  progress: Animated.SharedValue<number>;
}

export const Subtitles = observer<ISubtitlesProps>(
  ({ store, subtitles, progress }) => {
    const insets = useSafeAreaInsets();
    const videoPlayerSettings = useVideoPlayerSettings();

    const selectedSubtitles = useMemo(
      () =>
        videoPlayerSettings.subtitlesLanguage && subtitles
          ? subtitles[videoPlayerSettings.subtitlesLanguage]
          : null,
      [
        subtitles && videoPlayerSettings.subtitlesLanguage
          ? subtitles[videoPlayerSettings.subtitlesLanguage]
          : subtitles,
        videoPlayerSettings.subtitlesLanguage,
      ],
    );

    return !!selectedSubtitles &&
      videoPlayerSettings.isEnabledSubtitles ? (
      <Container
        insets={insets}
        isInFullScreen={store.isInFullScreen}
      >
        <SubtitlesText
          progress={progress}
          subtitles={selectedSubtitles}
        />
      </Container>
    ) : null;
  },
);
